import React, { useEffect } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import { saveUserStorage, UserStorage, flatObj } from "../units";
import { getUserInfo } from "../service";
import bg from '../images/user-bg.jpg'
import bg1 from '../images/certified.png'
import logo from '../images/logo2020.png'
import bgLogo from '../images/bg-logo.png'
import { useDispatch, useSelector } from "react-redux";
import { userInfoAction } from "../store/actions";
import { State } from "../store/reducer";
import { useModal } from "../components/modal";
import { parse } from "qs";
import icon from '../images/cicon.png'

const stars = ['普通会员', '一星管家', '二星管家', '三星管家', '首席大管家']


function User() {

    const userInfo = useSelector<State, State["userInfo"]>(state => state.userInfo)
    const search = useLocation().search;
    const dispatch = useDispatch()
    const { push, goBack } = useHistory()
    const modal = useModal()
    const userId = search ? parse(search.replace(/\?/, '')).userId : null

    useEffect(() => {

        if (userId) {
            getUserInfo({
                userId: (userId as string)
            }).then(res => {
                if (res.code === 1) {
                    const data = flatObj<UserStorage>(res.data)
                    saveUserStorage(data)
                    dispatch(userInfoAction(res.data))
                }
            })

            return
        }

        if (userInfo === null) {
            modal.show({
                content: '该功能需要用户登录，是否继续?',
                confirmText: '用户登陆',
                cancelText: '取消浏览',
                success(res) {
                    if (res.confirm) {
                        push('/login')
                    } else {
                        goBack()
                    }
                }
            })
        } else {
            getUserInfo({
                userId: userInfo.id
            }).then(res => {
                if (res.code === 1) {
                    const data = flatObj<UserStorage>(res.data)
                    saveUserStorage(data)
                    dispatch(userInfoAction(res.data))
                }
            })
        }
    }, [])

    return <div className="user" style={{ backgroundColor: '#fff' }}>
        <div className="top">
            <img src={userInfo?.certified ? bg1 : bg} alt="" />
            <div className="wrapper">

                {
                    userInfo?.certified && <img className="certified" src={icon} alt="" />
                }

                <div className="header">
                    <div className="avatar">
                        <div className="bg" style={{ backgroundImage: `url(${userInfo?.avatarUrl})` }} />
                    </div>
                    <div className="left">
                        {
                            userInfo?.nickName ? <h3>{userInfo.nickName}</h3> : <h3>用户#{userInfo?.customerMobile.slice(-4)}</h3>
                        }

                    </div>

                    <Link to={'/user/info'} className='set'>
                        <p className="iconfont">&#xe602;</p>
                    </Link>

                </div>

                <div className="statistics">
                    <div className="item">
                        <h3>{userInfo ? Math.floor((Date.now() - userInfo?.createTime) / (1000 * 60 * 60 * 24)) : 0}</h3>
                        <p>学习天数</p>
                    </div>
                    <div className="item">
                        <h3 style={{ fontSize: '.3rem' }}>{userInfo?.stars ? stars[userInfo.stars] : '普通会员'}</h3>
                        <p>管家星级</p>
                    </div>
                    <div className="item">
                        <h3>0</h3>
                        <p>我的课程</p>
                    </div>
                    {/*<div className="item">*/}
                    {/*    <h3>4<span>星</span></h3>*/}
                    {/*    <p>管家星级</p>*/}
                    {/*</div>*/}
                </div>
            </div>
        </div>
        <div className="space" />
        <div className="md">
            <Link to={'/course/mine'}>
                <p className="iconfont">&#xe600;</p>
                <p className='title'>我的课程</p>
            </Link>
            <Link to={'/user/certificate'}>
                <p className="iconfont">&#xe601;</p>
                <p className='title'>我的证书</p>
            </Link>
            <Link to={'/user/resume'}>
                <p className="iconfont">&#xe659;</p>
                <p className='title'>我的简历</p>
            </Link>
            <Link to={'/user/offline'}>
                <p className="iconfont">&#xe6f8;</p>
                <p className='title'>线下课程</p>
            </Link>
        </div>
        <Link className="BG" to={'/home/certification'}>
            <p className='left'>
                <img src={bgLogo} alt="" />
                {
                    (userInfo && userInfo.certified) ? <span className="is">尊贵的BG会员</span> : <span>年度会员可享海量联盟福利</span>
                }
            </p>
            <p > {userInfo?.certified && <span className="asd">去续费</span>} <span className="iconfont">&#xe608;</span></p>
        </Link>
        <div className="lists grey">
            <Link to={ userInfo?.referee ? '/home/distribution/lists' : '/home/distribution'}>
               <div className="name">
                   <p className="iconfont">&#xe61f;</p>
                   <p className='title'>课程分销</p>
            </div>
                <p className="iconfont">&#xe608;</p>
            </Link>
            <Link to={'/user/discount'}>
                <div className="name">
                    <p className="iconfont">&#xe607;</p>
                    <p className='title'>我的券包</p>
                </div>
                <p className="iconfont">&#xe608;</p>
            </Link>

            <Link to={'/user/order'}>
                <div className="name">
                    <p className="iconfont">&#xe668;</p>
                    <p className='title'>我的订单</p>
                </div>
                <p className="iconfont">&#xe608;</p>
            </Link>

            <Link to={'/user/active'}>
                <div className="name">
                    <p className="iconfont">&#xe603;</p>
                    <p className='title'>社群活动</p>
                </div>
                <p className="iconfont">&#xe608;</p>
            </Link>
            <Link to={'/user/grades'}>
                <div className="name">
                    <p className="iconfont">&#xe7ae;</p>
                    <p className='title'>会员权益</p>
                </div>
                <p className="iconfont">&#xe608;</p>
            </Link>

            <div className="space" />

            <Link to={'/user/info'}>
                <div className="name">
                    <p className="iconfont">&#xe602;</p>
                    <p className='title'>用户设置</p>
                </div>
                <p className="iconfont">&#xe608;</p>
            </Link>

            <Link to={'/user/help'}>
                <div className="name">
                    <p className="iconfont">&#xe62c;</p>
                    <p className='title'>问题反馈</p>
                </div>
                <p className="iconfont">&#xe608;</p>
            </Link>

            <div className="space" />

        </div>
        {/*<div className="tip">*/}
        {/*    <p>咨询电话：156 *** *** 周一至周六 10：00-19：00</p>*/}
        {/*</div>*/}
        <div className="showun">
            <a href="https://www.shuwon.com">
                <img src={logo} alt="" /> 提供技术支持</a>
        </div>
    </div>
}

export default User
